import axios from "axios";

// api calls
export const apiCalls = (method, url, data = {}) => {
  if (method === "get") {
    // only for get
    return axios({ method: method, url: url, params: data });
  } else {
    // post, put, delete
    return axios({ method: method, url: url, data: data });
  }
};

// auth api calls
export const authApiCalls = (method, url, data = {}) => {
  const headers = { auth: "e7k03X4BHEYEzO3n9eFv"};
  if (method === "get") {
    // only for get
    return axios({ method: method, url: url, params: data, headers: headers });
  } else {
    // post, put, delete
    return axios({ method: method, url: url, data: data, headers: headers });
  }
};

// auth api calls with Header
export const authApiHeader = (method, url, headerdata, data = {}) => {
  const headers = headerdata;
  if (method === "get") {
    // only for get
    return axios({ method: method, url: url, headers: headers, params: data });
  } else {
    // post, put, delete
    return axios({ method: method, url: url, headers: headers, data: data });
  }
};

// Added axios global variable
// axios.interceptors.request.use(
//   config => {
//     const token = getUserToken();

//     if (token) {
//       config.headers.Authorization = `Bearer ${token}`;
//     }

//     return config;
//   },
//   error => Promise.reject(error)
// );
// axios.defaults.headers.post["Content-Type"] = "application/json";